import { get } from 'lodash';
import PropTypes from 'prop-types';
import { TRO, LC } from '../../../constants/measure';

export const MILLISECONDS_PER_SECOND = 1000;

export const TRO_DEMO_VIDEO_PLAYER_ID = 'TROPractice';
export const LC_DEMO_VIDEO_PLAYER_ID = 'LCDemo';
export const PLAYLISTS = {
    [TRO.MEASURE]: TRO_DEMO_VIDEO_PLAYER_ID,
    [LC.MEASURE]: LC_DEMO_VIDEO_PLAYER_ID
};

export const TRC_PRACTICE_VIDEO_BUCKET_CDN = 'https://lantern-cdn.aws.wgen.net/practicetrco';
export const LC_DEMO_VIDEO_BUCKET_CDN = 'https://lantern-lc-multimedia.aws.wgen.net/videos';

export const PROGRESS_START = 0;
export const PROGRESS_END = 100;

export const JPLAYER_ACTION_KEYS = {
    DURATION: 'duration',
    CURRENT_TIME: 'currentTime',
    CURRENT_PERCENT_RELATIVE: 'currentPercentRelative',
};

export const CONTROL_TYPE = {
    PLAY: 'play',
    PAUSE: 'pause',
    REPEAT: 'repeat',
};

export const PLAYLIST_START_INDEX = 0;

const LC_OPTIONS = {
    loop: false,
    autoplay: false,
    id: LC_DEMO_VIDEO_PLAYER_ID,
    lcPracticeVideoBucketCDN: LC_DEMO_VIDEO_BUCKET_CDN,
};

const TRO_OPTIONS = {
    loop: false,
    autoplay: false,
    id: TRO_DEMO_VIDEO_PLAYER_ID,
    trcPracticeVideoBucketCDN: TRC_PRACTICE_VIDEO_BUCKET_CDN,
};

if (process.env.NODE_ENV !== 'development' && get(window, 'amplify_lantern_config.lcCDNUrl')) {
    LC_OPTIONS.lcPracticeVideoBucketCDN = `${window.amplify_lantern_config.lcCDNUrl}/videos`;
}

if ( process.env.NODE_ENV !== 'development' && get(window, 'amplify_lantern_config.trcPracticeVideoBucket') ) {
    TRO_OPTIONS.trcPracticeVideoBucketCDN = window.amplify_lantern_config.trcPracticeVideoBucket;
}

export {LC_OPTIONS, TRO_OPTIONS};

export const TRO_PLAYLIST = {
    READING_BOOKS: {
        TITLE: 'Reading books',
        ID: 'readingVideo',
        FILE_NAME: 'book_reading.mp4',
        INDEX: 0,
    },
    ANSWERING_QUESTIONS: {
        TITLE: 'Answering questions',
        ID: 'questionsVideo',
        FILE_NAME: 'answering_questions.mp4',
        INDEX: 1
    },
};

export const LC_PLAYLIST = {
    LC_PRACTICE: {
        TITLE: 'Listening Comprehension Practice',
        ID: 'lc_practice',
        FILE_NAME: 'lc_practice.mp4',
        INDEX: 0,
    },
};

export const JPLAYERS_TYPE = PropTypes.objectOf(
    PropTypes.shape({
        newTime: PropTypes.number,
        guiFadeOut: PropTypes.bool,
        playHeadPercent: PropTypes.number,
        mediaSettings: PropTypes.shape({
            video: PropTypes.bool,
            foundSupported: PropTypes.bool,
            formats: PropTypes.arrayOf(
                PropTypes.shape({
                    supplied: PropTypes.string,
                    supported: PropTypes.string,
                }),
            ),
        }),
        paused: PropTypes.bool,
        seeking: PropTypes.bool,
        src: PropTypes.string,
        currentTimeText: PropTypes.string,
        durationText: PropTypes.string,
        seekPercent: PropTypes.number,
        currentPercentRelative: PropTypes.number,
        currentPercentAbsolute: PropTypes.number,
        currentTime: PropTypes.number,
        duration: PropTypes.number,
        bufferedTimeRanges: PropTypes.arrayOf(
            PropTypes.shape({
                start: PropTypes.number,
                end: PropTypes.number,
            }),
        ),
        focused: PropTypes.bool,
        preload: PropTypes.string,
        minPlaybackRate: PropTypes.number,
        maxPlaybackRate: PropTypes.number,
        playbackRate: PropTypes.number,
        defaultPlaybackRate: PropTypes.number,
        bufferColour: PropTypes.string,
        volume: PropTypes.number,
        barDrag: PropTypes.bool,
        pauseOthersOnPlay: PropTypes.bool,
        guiFadeHoldTime: PropTypes.number,
        media: PropTypes.shape({
            sources: PropTypes.shape({
                m4v: PropTypes.string,
            }),
            title: PropTypes.string,
            artist: PropTypes.string,
            poster: PropTypes.string,
            free: PropTypes.bool,
            demoVideoId: PropTypes.string,
            id: PropTypes.string,
            shufflePosition: PropTypes.number,
        }),
        keyBindings: PropTypes.object,
        showRemainingDuration: PropTypes.bool,
        muted: PropTypes.bool,
        loop: PropTypes.bool,
        autoplay: PropTypes.bool,
        smoothPlayBar: PropTypes.bool,
        fullScreen: PropTypes.bool,
        verticalPlaybackRate: PropTypes.bool,
        verticalVolume: PropTypes.bool,
        keyEnabled: PropTypes.bool,
        timeFormats: PropTypes.shape({
            showHour: PropTypes.bool,
            showMin: PropTypes.bool,
            showSec: PropTypes.bool,
            padHour: PropTypes.bool,
            padMin: PropTypes.bool,
            padSec: PropTypes.bool,
            sepHour: PropTypes.string,
            sepMin: PropTypes.string,
            sepSec: PropTypes.string,
        }),
        id: PropTypes.string,
        trcPracticeVideoBucketCDN: PropTypes.string,
        volumeSupported: PropTypes.bool,
    }),
);

export const DEMO_VIDEOS_PROGRESS_TYPE = PropTypes.shape({
    progress: PropTypes.number,
    currentTime: PropTypes.number,
    duration: PropTypes.number,
    watched: PropTypes.bool,
});

export const JPLAYLISTS_PLAYLIST_ITEM_TYPE = PropTypes.shape({
    artist: PropTypes.string,
    title: PropTypes.string,
    demoVideoId: PropTypes.string,
    sources: PropTypes.shape({ m4v: PropTypes.string }),
    id: PropTypes.string,
    shufflePosition: PropTypes.number,
});

export const JPLAYLIST_TYPE = PropTypes.shape({
    current: PropTypes.number,
    shuffled: PropTypes.bool,
    loopOnPrevious: PropTypes.bool,
    shuffleOnLoop: PropTypes.bool,
    loop: PropTypes.string,
    hidePlaylist: PropTypes.bool,
    playlist: PropTypes.arrayOf(JPLAYLISTS_PLAYLIST_ITEM_TYPE),
});

export const JPLAYLISTS_TYPE = PropTypes.objectOf(JPLAYLIST_TYPE);


export const DURATION_REGEX = /^[0-9]+:[0-9]{2}$/;
export const FORMATTED_DURATION_REGEX = /^\/[0-9]+:[0-9]{2}$/;
